/**
 * This component should always be lazy-loaded.
 */
export const loadOnboardingChunk = () => {
  return import('./Onboarding');
};
